import React from 'react';

export const validatePercentageField = (
    event: React.KeyboardEvent<HTMLInputElement>,
    currentValue: string,
    maxDecimals = 3
): boolean => {
    const normalizedValue = currentValue.replace('%', '');
    const decimalLength = (value: string) =>
        value.includes('.') ? (value.split('.').pop()?.length ?? 0) : 0;
    const selectionStart = event.currentTarget.selectionStart ?? 0;
    const isChangeAfterDot = selectionStart > normalizedValue.length - 2;
    const isMaxDecimalsReached = decimalLength(normalizedValue) >= maxDecimals;

    if (
        !/[0-9]/.test(event.key) &&
        event.key !== 'Backspace' &&
        event.key !== 'ArrowRight' &&
        event.key !== 'ArrowLeft' &&
        event.key !== 'Tab' &&
        (event.key !== '.' || normalizedValue.includes('.'))
    ) {
        return true;
    }

    if (event.key === '.' && !isChangeAfterDot) {
        return true;
    }

    if (/[0-9]/.test(event.key) && isMaxDecimalsReached && isChangeAfterDot) {
        return true;
    }

    return false;
};
